import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SendEnrollmentPacketMutation = graphql.persisted(
  "SendEnrollmentPacket",
  graphql(`
    mutation SendEnrollmentPacket($familyEnrollmentId: ID!, $forceSendWithoutInvoices: Boolean) {
      sendEnrollmentPacket(input: {familyEnrollmentId: $familyEnrollmentId, forceSendWithoutInvoices: $forceSendWithoutInvoices}) {
        familyEnrollment { id state packetSentAt inviteToken }
        userErrors { message path }
      }
    }
  `)
);

export { SendEnrollmentPacketMutation };

export function useSendEnrollmentPacket() {
  return useMutation(SendEnrollmentPacketMutation);
}
